import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import DialogModal from '../../common/DialogModal';
import { DialogType, TimelineLabelType } from '../../../constants/ComponentTypes';
import { hasKLFollowCallBeenEnabled, isKLFollowCall } from '../../../utils/userUtils';
import Input from 'material-ui/Input';
import { FormControl } from 'material-ui/Form';
import Select from 'material-ui/Select';
import MenuItem from 'material-ui/Menu/MenuItem';
import Button from '../../Parts/Button'
import SectionHead from './parts/SectionHead'
import DatePicker from "react-datepicker";
import { connect } from 'react-redux';
import moment from 'moment';

const styles = () => ({
  paper: {
    maxHeight: 'unset',
    background: "#F4F6F9",
    width: '600px',
  },

  contentContainer: {
    padding: '25px',
    margin: 0,
    textAlign: 'left',
  },

  container: {
    width: '100%',
  },

  description: {
    fontSize: '14px',
    color: '#F03A47',
    marginBottom: '15px',
    fontWeight: 'bold',
  },

  inputMultiline: {
    padding: '10px 12px',
    fontSize: '15px',
  },

  buttonContainer: {
    display: 'inline-flex',
    width: '100%',
    justifyContent: 'space-evenly',
    margin: '40px 0',
  },

  row: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '15px',
    alignItems: 'center',
  },

  rowItem: {
    width: 'calc(50% - 10px)',
  },

  datePicker: {
    position: 'absolute',
    right: '0',
    top: '50px',
    zIndex: 1,
  }
});


class CustomStatusDialog extends React.Component {
  state = {
    title: '',
    desc: '',
    label: 99,
    address: '',
    scheduled_at: moment(),
    remind_at: 5,
    showDatePicker: false,
  }

  componentWillMount() {
    this.setItem(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isPosting && !nextProps.isPosting) {
      this.props.toggleDialog();
    }
  }

  setItem = (props) => {
    if (props.type === DialogType.EDIT && !!props.item) {
      this.setState({
        title: props.item.title || '',
        desc: props.item.desc || '',
        label: props.item.status_label_type,
        address: props.item.address || '',
        scheduled_at: props.item.scheduled_at ? moment(props.item.scheduled_at) : moment(),
      })
    }
  }

  toggleDatePicker = () => {
    this.setState({ showDatePicker: !this.state.showDatePicker });
  }

  handleChange = property => (e) => {
    if (property === 'hour') {
      this.setState({
        scheduled_at: moment(this.state.scheduled_at).hour(e.target.value),
      })
    } else if (property === 'minute') {
      this.setState({
        scheduled_at: moment(this.state.scheduled_at).minute(e.target.value),
      })
    } else {
      this.setState({
        [property]: e.target.value
      })
    }
  }

  handleChangeLabel = (e) => {
    let title = ""
    switch (e.target.value) {
      case TimelineLabelType.APPOINTMENT.value:
        title = "アポを獲得しました";
        break;
      case TimelineLabelType.CLOSE.value:
        title = "クローズしました";
        break;
      case TimelineLabelType.APPROACH_NG.value:
        title = "アプローチNG";
        break;
      default:
        break;
    }

    if (this.props.type === DialogType.CREATE) {
      this.setState({
        title: title,
      })
    }

    this.setState({
      label: e.target.value
    })
  }

  handleSave = () => {
    if (isKLFollowCall(this.props.user) && this.props.hasFollowCallAddress && this.state.label === TimelineLabelType.APPOINTMENT.value) {
      alert('商談獲得の場合は大変お手数ですが弊社BDR担当までご連絡ください。');
      return;
    }

    let query = {
      "title": this.state.title,
      "desc": this.state.desc,
      "status_label_type": this.state.label,
    }

    if (this.state.label === TimelineLabelType.APPOINTMENT.value) {
      query["address"] = this.state.address;
      query["scheduled_at"] = this.state.scheduled_at.format('YYYY-MM-DD HH:mm:ss');
    }

    if (this.props.type === DialogType.EDIT) {
      query["timeline_status_id"] = this.props.item.id;
    }

    query["with_ownership_user"] = true;

    this.props.save(query)
  }

  handleChangeDate = (scheduled_at) => {
    this.setState({
      showDatePicker: false,
      scheduled_at: moment(scheduled_at)
    })
  }

  render() {
    const { classes, toggleDialog, isOpen, type, user } = this.props;

    // システムが自動で設定すべき項目であるためタイムライン画面の選択値に表示しない
    const hiddenStatuses = [
      TimelineLabelType.RESERVE.value,
      TimelineLabelType.APPROACH.value,
      TimelineLabelType.PROOFREAD_CREATED.value,
      TimelineLabelType.ORDER_PRINTING.value,
      TimelineLabelType.ORDER_SHIPPED.value,
    ].concat(
      // 一度でもフォローコールを依頼してなければ、フォローコールのステータスは表示しない
      !hasKLFollowCallBeenEnabled(user) ? [
        TimelineLabelType.NON_CONNECT.value,
        TimelineLabelType.DECLINED.value,
        TimelineLabelType.CONNECT.value,
        TimelineLabelType.SENT_DOCUMENT.value,
      ] : []
    );

    const hoursAtDay = 24;
    const minutesAtHour = 60;
    const invalidNum = 99;

    // タイトルと説明が必須
    const isDisabledStore = this.state.label === invalidNum || (!this.state.title || !this.state.desc);

    return (
      <DialogModal
        title={type === DialogType.CREATE ? 'ステータスを追加' : 'ステータスを編集'}
        open={isOpen}
        onClose={toggleDialog}
        maxWidth={false}
        classes={{
          paper: classes.paper,
          contentContainer: classes.contentContainer
        }}
      >
        <div className={classes.container}>
          <div className={classes.description}>※ダッシュボードの数値やステータス別の一覧の反映にはしばらく時間がかかります。ご了承くださいませ。</div>
          <SectionHead text="ステータスラベルを選択" />
          <FormControl fullWidth style={{ marginBottom: '15px' }}>
            <Select
              value={this.state.label}
              onChange={this.handleChangeLabel}
              disableUnderline={true}
              fullWidth
            >
              <MenuItem key={99} value={99}>選択してください</MenuItem>
              {Object.values(TimelineLabelType).map(label => {
                if (!hiddenStatuses.includes(label.value)) {
                  return (
                    <MenuItem
                      key={label.value} value={label.value}>
                      {label.text}
                    </MenuItem>
                  );
                } else {
                  return null;
                }
              })}
            </Select>
          </FormControl>

          <SectionHead text="メモを追加" />
          <Input
            value={this.state.title}
            disableUnderline={true}
            placeholder="タイトルを入力"
            onChange={this.handleChange("title")}
            fullWidth
            style={{ marginBottom: '20px' }}
          />

          <Input
            value={this.state.desc}
            disableUnderline={true}
            multiline={true}
            rows={5}
            placeholder="説明を入力"
            onChange={this.handleChange("desc")}
            fullWidth
            classes={{
              inputMultiline: classes.inputMultiline
            }}
          />
        </div>

        {(() => {
          if (this.state.label === TimelineLabelType.APPOINTMENT.value) {
            return (
              <div>
                <div className={classes.row}>
                  <div className={classes.rowItem} style={{ marginRight: '20px' }}>
                    <SectionHead text="面会の日にち" />
                    <FormControl fullWidth>
                      <Select
                        value={0}
                        onClick={this.toggleDatePicker}
                        MenuProps={{
                          open: false,
                        }}
                        disableUnderline={true}
                        fullWidth
                      >
                        <MenuItem key={0} value={0}>{this.state.scheduled_at.format('YYYY年M月D日')}</MenuItem>
                      </Select>
                      {this.state.showDatePicker && (
                        <div className={classes.datePicker}>
                          <DatePicker
                            id="date-picker"
                            locale="ja"
                            dateFormat={"yyyy/MM/dd"}
                            dateFormatCalendar={"yyyy年MM月"}
                            inline
                            selected={new Date(this.state.scheduled_at.toDate())}
                            onChange={this.handleChangeDate}
                            maxDate={moment().add(1, 'months').endOf("month").toDate()}
                          />
                        </div>
                      )}
                    </FormControl>
                  </div>

                  <div className={classes.rowItem}>
                    <SectionHead text="面会の時間" />

                    <div className={classes.row}>
                      <FormControl fullWidth className={classes.rowItem}>
                        <Select
                          value={moment(this.state.scheduled_at).format('H')}
                          onChange={this.handleChange("hour")}
                          onFocus={() => this.setState({ showDatePicker: false })}
                          disableUnderline={true}
                          fullWidth
                        >
                          {Array.from(Array(hoursAtDay).keys()).map((hour, i) => (
                            <MenuItem key={i} value={hour.toString()}>{hour.toString()}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <div>:</div>
                      <FormControl fullWidth className={classes.rowItem}>
                        <Select
                          value={moment(this.state.scheduled_at).format('m')}
                          onChange={this.handleChange("minute")}
                          onFocus={() => this.setState({ showDatePicker: false })}
                          disableUnderline={true}
                          fullWidth
                        >
                          {Array.from(Array(minutesAtHour).keys()).map((minute, i) => (
                            <MenuItem key={i} value={minute.toString()}>{minute.toString()}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                </div>
                <div className={classes.row}>
                  <div className={classes.rowItem} style={{ marginRight: '20px' }}>
                    <SectionHead text="面会場所の住所" />

                    <Input
                      value={this.state.address}
                      disableUnderline={true}
                      placeholder="住所を入力"
                      onChange={this.handleChange("address")}
                      fullWidth
                    />
                  </div>
                  <div className={classes.rowItem}>
                  </div>
                </div>
              </div>
            )
          }
        })()}

        <div className={classes.buttonContainer}>
          <Button
            handleClickButton={toggleDialog}
            size="large"
            text="キャンセル"
            type="ghost">
          </Button>

          <Button
            handleClickButton={this.handleSave}
            size="large"
            loading={this.props.isPosting}
            disabled={isDisabledStore}
            text="保存"
          >
          </Button>
        </div>
      </DialogModal>
    );
  }
}

CustomStatusDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  type: PropTypes.number,
  save: PropTypes.func.isRequired,
  item: PropTypes.object,
  isPosting: PropTypes.bool,
  hasFollowCallAddress: PropTypes.bool,
};

const mapStateToProps = (state) => {
  return {
    user: state.accountSetting.user,
    isPosting: state.timeline.isPostingStatus
  };
};

export default withStyles(styles)(connect(
  mapStateToProps,
)(CustomStatusDialog));



// WEBPACK FOOTER //
// ./src/components/Timeline/dialogs/CustomStatusDialog.jsx